import { render } from "./opTh.vue?vue&type=template&id=29bce0b8&ts=true"
import script from "./opTh.vue?vue&type=script&lang=ts"
export * from "./opTh.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__